import { ApiService } from './../api.service';
import { EventEmitter, Injectable, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { Login } from 'src/app/interfaces/login';
import { LocalstorageService } from '../storage/localstorage.service';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { AmbienteSefazService } from '../ambiente-sefaz/ambiente-sefaz.service';


@Injectable({
  providedIn: 'root'
})
export class ApiLoginService {

  Login: Login = {} as Login;

  listaMenu:Array<any> = [
    {
      id: 1,
      titulo: "Cadastros"
    },
    {
      id: 2,
      titulo: "Consultas"
    },
    {
      id: 3,
      titulo: "Pendências"
    },
    {
      id: 4,
      titulo: "Regras"
    },
    {
      id: 5,
      titulo: "Configurações"
    }
  ]

  listaMenuPerfil:any = {
    cadastro:false,
    regras:false,
    configuracao:false,
    consultas:false,
    pendencias:false
  }
  
  listaSubMenus: Array<any> = [
    {
      id:2,
      hidden:false
    },
    {
      id:4,
      hidden:false
    },
    {
      id:5,
      hidden:false
    },
    {
      id:15,
      hidden:false
    },
    {
      id:15,
      hidden:false
    },
    {
      id:14,
      hidden:false
    },
    {
      id:13,
      hidden:false
    },
    {
      id:12,
      hidden:false
    },
    {
      id:8,
      hidden:false
    },
    {
      id:10,
      hidden:false
    },
    {
      id:9,
      hidden:false
    },
    {
      id:7,
      hidden:false
    },

    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },
    {
      id:11,
      hidden:false
    },

    {
      id:3,
      hidden:false
    },
    {
      id:3,
      hidden:false
    },
    {
      id:3,
      hidden:false
    },
    {
      id:3,
      hidden:false
    },
    {
      id:3,
      hidden:false
    },
    
    {
      id:17,
      hidden:false
    },
    {
      id:16,
      hidden:false
    },
    
    {
      id:19,
      hidden:false
    },
    {
      id:20,
      hidden:false
    },
    {
      id:21,
      hidden:false
    },
    {
      id:30,
      hidden:false
    },
    {
      id:22,
      hidden:false
    },
    {
      id:23,
      hidden:false
    }
  ];

  permissoes: any;  

  @Output() mostraMenu = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private API: ApiService,
    public localStorage: LocalstorageService,
    private ambienteSefaz: AmbienteSefazService
  ) { }

  loginAtivo(login: any) {
    const _self = this;
    _self.API.getFromApi('Login', 'Login', login,
      (async (Retorno: {listaUsuariosLogado: any; status: boolean;}) => {
        if (Retorno.status == true) {
          login.usuarioAutenticado = true;
          let usuarioLogado = Retorno.listaUsuariosLogado[0];
          this.mostraMenu.emit(true);
          this.mostraMenu.subscribe(() => login.usuarioAutenticado = true);
          login.senha = '********';
          this.localStorage.setData('LOGIN', login);
          usuarioLogado.perfil.listaMenu = usuarioLogado.perfil.listaMenu.filter((menu: { sistema: string; }) => menu.sistema.toLowerCase() == 'web');
          this.localStorage.setData('USUARIO', usuarioLogado);
          this.router.navigate(['/']);
          // console.log('RETORNO FROM API = ', Retorno);
        }else{
          login.token = "";
          login.usuarioAutenticado = false;
          this.mostraMenu.emit(false);
          document.getElementById('show-modal')?.click();
          this.router.navigate(['/login']);
        }
      })
      , true, "")
  }

  verificarFatores(Login:any){
    const _self = this
    var verificar:boolean;
    // this.http.get("assets/config.json?" + Math.random()).subscribe( async data => {
    //   let verificar = JSON.parse(JSON.stringify(data))
    //   verificar = verificar.codConfirm
    //   return verificar
    // })
    // DESENVOLVER APÓS A INTEGRAÇÃO //

    // _self.API.getFromApi('VerificarSegundoFator', 'Select', {id:Login.usuario, empresa: Login.senha}, (Permissoes:any) =>{
    //   _self.permissoes = Permissoes
    //   this.localStorage.setData('PERMISSOES', Permissoes);


    //   return verificar
    // },true,"")

    //TST//
    // verificar = true;
    //TST//

    
  }

  async loginPermissoes(login: any) {
    const _self = this;
    var obj = {
      cod_empresa   : login.cod_empresa,
      login         : login.usuario,
      senha         : login.senha,
      manter        : login.manter
    }
    _self.API.getFromApi('Login', 'Login', obj, (Permissoes:any) =>{
      if(Permissoes.status){
        var dados = Permissoes.dados
        this.localStorage.setData('PERMISSOES', Permissoes.dados);
        login.senha = '********';
        
        login.perfil = {
          listaMenu: []
        };
        for(let i = 0; i < _self.listaMenu.length; i++){
          for(let j = 0; j < dados.permissoes.length; j++){
            if(_self.listaMenu[i].id == dados.permissoes[j].grupo_menu){
              login.perfil.listaMenu.push(_self.listaMenu[i])
              switch(_self.listaMenu[i].id){
                case 1:
                  this.listaMenuPerfil.cadastro = true
                  break;
                case 2:
                  this.listaMenuPerfil.consultas = true
                  break;
                case 3:
                  this.listaMenuPerfil.configuracoes = true
                  break;
                case 4:
                  this.listaMenuPerfil.regras = true
                  break;
                case 5:
                  this.listaMenuPerfil.pendencias = true
                  break;
              }
              break;
            }
          }
        }
        
        // login.empresa_id = Number(login.empresa_id);
        
        for(let i = 0; i < login.empresas.length; i++){
          if(login.empresas[i].id_nfer_empresa == login.empresa_id){
            login.empresa_nome = login.empresas[i].den_empresa;
            login.cod_estab = login.empresas[i].cod_estab
            break;
          }
        }
        
        login.cod_usuario = dados.cod_usuario
        login.licenca = dados.licenca
        this.localStorage.setData('USUARIO', login);
        delete login.empresas
        login.manter = dados.manter

        var objLogin = {
          cod_empresa        : login.cod_empresa,
          empresa_id         : login.empresa_id,
          cod_usuario        : login.cod_usuario,
          usuario            : login.usuario,
          senha              : login.senha,
          usuarioAutenticado : login.usuarioAutenticado,
          manter             : login.manter
        }
        
        _self.localStorage.setData('LOGIN', objLogin);
        _self.localStorage.setData('PARAM_PEND',false);
        _self.localStorage.setData('PARAM_ALERT', dados.parametro_alert);
        // _self.localStorage.setData('SEFAZ_PRD_HML', dados.sefaz_prod_homolog);
        _self.ambienteSefaz.setStatus(!dados.sefaz_prod_homolog)
        
        this.mostraMenu.emit(true);
        this.mostraMenu.subscribe(() => login.usuarioAutenticado = true);
        this.router.navigate(['/home']);
      }else{
        
      }
    },true,"")
      

  }

  logout() {
    this.Login.usuarioAutenticado = false;
    this.mostraMenu.emit(this.Login.usuarioAutenticado);
    this.listaMenuPerfil = {
      cadastro:false,
      regras:false,
      configuracao:false,
      consultas:false,
      pendencias:false
    }
    this.localStorage.removeData('LOGIN')
    this.localStorage.removeData('USUARIO')
    this.localStorage.removeData('CONFIG')
    this.localStorage.removeData('PERMISSOES')
    this.localStorage.removeData('VERSAO')
    this.localStorage.removeData('SESSION')
    this.localStorage.removeData('TwoFactAuth')
    this.localStorage.removeData('OTPVALID')
    this.ambienteSefaz.setStatus(true)
    this.router.navigate(['/login']);
  }

  loginXML(Login: any){
    return new Promise((resolve, reject) => {
      const _self = this;
        
        _self.API.getFromApi('Usuarios', 'CarregaEmpresas', {login: Login.usuario, senha: Login.senha}, (Credenciais:any) => {
          // console.log('RETORNO API = ', Credenciais);
          if(Credenciais.status == true){
            
            Login.usuarioAutenticado = true;

            Login.empresas = Credenciais.empresas;
            resolve(Login);
          }else{
            Login.usuarioAutenticado = false;
            Login.empresas = [];
            resolve(Login);
          }
        }, true,'')
    })
    

  }

  //função utilizada no auth.guard.ts
  usuarioEstaAutenticado() {
    const loginStorage = this.localStorage.getData('LOGIN');
    if (loginStorage != undefined) {
      this.Login.usuarioAutenticado = JSON.parse(loginStorage).usuarioAutenticado
    }
    return this.Login.usuarioAutenticado
  }

  async getLoginStorage() {
    const loginStorage = this.localStorage.getData('LOGIN')
    if (loginStorage != undefined) {
      return JSON.parse(loginStorage)
    } else {
      return undefined
    }
  }

  async getUsuarioStorage() {
    const usuarioStorage = this.localStorage.getData('USUARIO')
    if (usuarioStorage != undefined) {
      return JSON.parse(usuarioStorage)
    } else {
      return undefined
    }
  }

  async getPermissoesStorage() {
    const permissoesStorage = this.localStorage.getData('PERMISSOES')
    if (permissoesStorage != undefined) {
      return JSON.parse(permissoesStorage)
    } else {
      return undefined
    }
  }

  novoLogin() {
    return this.Login = {
      senha: "",
      token: "",
      login: "",
      usuario: "",
      is_admin: false,
      usuarioAutenticado: false
    }
  }

  async versaoXML(){
    const _self = this;
    var versao = ''
    // var versao:any = new Promise((resolve,reject) => {
    //   _self.API.getFromApi('VersaoXML','Select',{},(Retorno:any) =>{
    //     console.log("Retorno API = ", Retorno)
    //     resolve(Retorno.versao) 
    //   },true,"")

    // })
    //TST//
    versao = '4.0.0'
    //TST//
    _self.localStorage.setData('VERSAO',versao);
    const versaoStorage = this.localStorage.getData('VERSAO')
    if (versaoStorage != undefined) {
      return JSON.parse(versaoStorage)
    } else {
      return undefined
    }
  }

  async getVersaoStorage() {
    const versaoStorage = this.localStorage.getData('VERSAO')
    if (versaoStorage != undefined) {
      return JSON.parse(versaoStorage)
    } else {
      return undefined
    }
  }
  
  async manterLogado() {
    const manterLogin = this.localStorage.getData('LOGIN')
    const TwoFactAuth = this.localStorage.getData('TwoFactAuth')
    var manterlogin:any = {};
    if (manterLogin != '[]') {
      var manterlogin = JSON.parse(manterLogin)
      if(manterlogin.manter){
        if(TwoFactAuth == 'false'){
          this.router.navigate(['/home']);
        }else{
          const otpvalid = JSON.parse(this.localStorage.getData('OTPVALID'))
          if(otpvalid.value){
            this.router.navigate(['/home']);
          }else{
            let login = JSON.parse(manterLogin)
            this.logout
            return false
          }
        }
      }else{
        this.Login.usuarioAutenticado = false;
        this.mostraMenu.emit(this.Login.usuarioAutenticado);
        this.localStorage.removeData('LOGIN')
        this.localStorage.removeData('USUARIO')
        this.router.navigate(['/']);
      }
    }else{
      manterlogin.manter = false
    }
    return JSON.parse(manterlogin.manter)
  }
  
}
